var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"warning"}},[(_vm.calcAreaPctTotal != 100)?_c('div',{staticClass:"alert alert-warning mt-2",attrs:{"role":"alert"}},[_vm._v("\n    Area fields must add up to 100%. They currently add up to "+_vm._s(_vm.calcAreaPctTotal)+"%!\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a7b7e5fc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Warning.vue
// module id = null
// module chunks = 